import React from 'react';
import styles from './SummaryPills.module.css';

export interface SummaryPillItem {
  label: string;
  value: string;
}

interface SummaryPillsProps {
  items: SummaryPillItem[];
  className?: string;
}

const SummaryPills: React.FC<SummaryPillsProps> = ({ items, className }) => (
  <div className={`${styles.pills}${className ? ` ${className}` : ''}`}>
    {items.map((item, i) => (
      <span key={i} className={styles.pill}>
        <span className={styles['pill-label']}>{item.label}</span>
        <span className={styles['pill-value']}>{item.value}</span>
      </span>
    ))}
  </div>
);

export default SummaryPills;
